// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconInk } from "../../../icons/mono/build/icon-ink.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const InkIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconInk.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  InkIcon.displayName = 'InkIcon';
}

export default InkIcon;